import React from 'react'

const Flag = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.79988 5.83988C6.79988 5.30969 7.22969 4.87988 7.75988 4.87988C8.29008 4.87988 8.71988 5.30969 8.71988 5.83988V6.79988H18.845C19.3621 6.79988 19.7106 7.32871 19.5067 7.80385L18.0664 11.1595C18.0118 11.2868 18.0148 11.4315 18.0747 11.5565L19.4428 14.4085C19.6721 14.8864 19.3237 15.4399 18.7936 15.4399H8.71988V22.1599H9.67988C10.2101 22.1599 10.6399 22.5897 10.6399 23.1199C10.6399 23.6501 10.2101 24.0799 9.67988 24.0799H5.83988C5.30969 24.0799 4.87988 23.6501 4.87988 23.1199C4.87988 22.5897 5.30969 22.1599 5.83988 22.1599H6.79988V5.83988Z"
        fill="#1072EB"
      />
    </svg>
  )
}

export default Flag
